/**
 * Finance settings for AP bank-clearing lag after Mark paid.
 * Doc: financeSettings/billPayClearing
 */

import {
  doc,
  onSnapshot,
  setDoc,
  Timestamp,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from './firebase';
import {
  DEFAULT_BILL_PAY_CLEARING,
  parseBillPayClearingSettings,
  type BillPayClearingSettings,
} from './billPayClearing';

export const BILL_PAY_CLEARING_DOC = 'billPayClearing';

export function subscribeBillPayClearingSettings(
  onNext: (settings: BillPayClearingSettings) => void,
  onError?: (err: Error) => void,
): Unsubscribe {
  const ref = doc(db, 'financeSettings', BILL_PAY_CLEARING_DOC);
  return onSnapshot(
    ref,
    (snap) => {
      onNext(parseBillPayClearingSettings(snap.exists() ? snap.data() : null));
    },
    (err) => onError?.(err),
  );
}

export async function saveBillPayClearingSettings(
  settings: BillPayClearingSettings,
  updatedBy?: string,
): Promise<void> {
  const ref = doc(db, 'financeSettings', BILL_PAY_CLEARING_DOC);
  await setDoc(
    ref,
    {
      achBusinessDays: settings.achBusinessDays,
      checkBusinessDays: settings.checkBusinessDays,
      cardDueDayOfMonth: settings.cardDueDayOfMonth,
      updatedAt: Timestamp.now(),
      ...(updatedBy ? { updatedBy } : {}),
    },
    { merge: true },
  );
}

export { DEFAULT_BILL_PAY_CLEARING };
